import React from 'react'
import { educations } from '../assets/data';
import "../styles/education.css";


const EducationSection = () => {
    return (
        <div className='section4 animation'>
            <h1 className='education_title'>Educations</h1>
            <div className='education_container'>
                {
                    educations.map((x) => {
                        return (
                            <div className='edu_details' key={x.key}>
                                <h2 className='edu_title'>{x.course} in <span className='edu_branch'>{x.branch}</span></h2>
                                <h4 className='college'>{' @ '}{x.college}</h4>
                                <span className='edu_desc'>{x.total_time}{' | '}{x.time}{' | '}{x.place}</span>
                            </div>
                        );
                    })
                }
            </div>
        </div>
    )
}

export default EducationSection